const messages = {
  title: {
    id: 'admin/promotions.form.progressive-discount.title',
  },
  cancel: {
    id: 'admin/promotions.utils.cancel',
  },
  apply: {
    id: 'admin/promotions.utils.apply',
  },
  trigger: {
    sameItemsOnly: {
      id: 'admin/promotions.form.utils.items.same-items-only',
    },
  },
  benefit: {
    quantity: {
      id: 'admin/promotions.form.progressive-discount.benefit.quantity',
    },
    discount: {
      id: 'admin/promotions.form.progressive-discount.benefit.discount',
    },
    add: {
      id: 'admin/promotions.form.progressive-discount.benefit.add',
    },
    count: {
      id: 'admin/promotions.form.progressive-discount.benefit.count',
    },
    remove: {
      id: 'admin/promotions.utils.remove',
    },
  },
  validation: {
    itemsRequired: {
      id: 'admin/promotions.form.skus-collections.validation.required',
    },
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    lessThanOrEquals: {
      id: 'admin/promotions.form.validation.less-than-equals',
    },
    duplicated: {
      id: 'admin/promotions.form.progressive-discount.validation.duplicated',
    },
  },
}

export default messages
